import { SvgIcon } from '@/lib';
import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CampaignSummaryContent } from './CampaignSummaryContent';
import { CampaignSummaryItemLabel } from './CampaignSummaryItemLabel';
import { CampaignSummaryItemField } from './types';

type CampaignSummaryItemProps = {
  index: number;
  title: string;
  content?: CampaignSummaryItemField[];
  label?: string;
  onClick?: ComponentProps<'button'>['onClick'];
} & PropsWithChildren;

export const CampaignSummaryItem: FC<CampaignSummaryItemProps> = ({ index, title, content, label, onClick }) => {
  return (
    <>
      <div className='flex w-full flex-col gap-4 rounded-xl bg-secondary-background p-4'>
        <header className='flex items-center justify-between overflow-hidden text-brand-600'>
          <span className='flex shrink-0 gap-1 *:font-semibold'>
            <p>{index}.</p>
            <p className='first-letter:capitalize'>{title}</p>
          </span>

          {onClick && (
            <button type='button' onClick={onClick}>
              <SvgIcon name='EditIcon' />
            </button>
          )}
        </header>
        {content && content.length ? <CampaignSummaryContent data={content} /> : null}
        {label ? <CampaignSummaryItemLabel text={label} /> : null}
      </div>
      <span className='h-[1.625rem] w-px bg-primary-border last-of-type:hidden' />
    </>
  );
};
